import { useGetParams } from '../../hooks/useGetParams';
import { iconsSources } from '../../helpers/icons';
import styles from './Photos.module.css';
import { useCarousel } from '../../hooks/useCarousel';

export const Photos = ({ messages }) => {
  const { showedMessages } = useCarousel(messages);
  const { withAvatar } = useGetParams();

  const errorHandler = (e, channel) => {
    e.target.src = iconsSources[channel];
  };

  return (
    <>
      {showedMessages?.map(
        (
          {
            UUID,
            message,
            randomTranslateX,
            randomTranslateY,
            randomDuration,
            randomSize,
            randomLeft,
          },
          index,
        ) => {
          const avatar = withAvatar
            ? message?.image && message?.image !== '1'
              ? message?.image
              : iconsSources[message?.channel]
            : iconsSources[message?.channel];

          return (
            <div
              key={UUID}
              className={styles['wrapper']}
              style={{
                transform: `translate(${randomLeft}%, ${randomTranslateY}rem)`,
                '--randomLeft': `${randomLeft}%`,
                '--randomTranslateY': `${randomTranslateY}rem`,
                animationDuration: `${randomDuration}s`,
              }}
            >
              <div
                className={styles['avatar']}
                style={{
                  width: `${randomSize}rem`,
                  height: `${randomSize}rem`,
                }}
              >
                <img
                  src={avatar}
                  alt={message?.author}
                  onError={(e) => errorHandler(e, message?.channel)}
                />
              </div>
            </div>
          );
        },
      )}
    </>
  );
};
